module.exports = __webpack_public_path__ + "static/img/application.1e2a872.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/document/application.png
// module id = AvRq
// module chunks = 0